import React from 'react'
import { Card, CardContent, Typography, Box, useTheme, alpha } from '@mui/material'

const AboutBox = (props) => {
  const { about } = props.tutor
  const theme = useTheme()

  return (
    <Card sx={{ 
      borderRadius: 3,
      boxShadow: `0 8px 24px ${alpha(theme.palette.common.black, 0.08)}`,
      border: `1px solid ${theme.palette.divider}`,
      overflow: 'hidden'
    }}>
      <CardContent sx={{ p: { xs: 2, sm: 2.5, md: 3 } }}>
        <Typography variant="h5" sx={{ 
          fontWeight: 700, 
          color: theme.palette.text.primary, 
          mb: 3,
          fontSize: { xs: '1.25rem', sm: '1.35rem', md: '1.5rem' },
          position: 'relative',
          '&::after': {
            content: '""',
            position: 'absolute',
            bottom: -8,
            left: 0,
            width: 40,
            height: 3,
            backgroundColor: theme.palette.primary.main,
            borderRadius: 2
          }
        }}>
          About the tutor
        </Typography>
        <Box 
          sx={{ 
            color: '#1a1a1a',
            lineHeight: 1.6,
            fontSize: { xs: '0.9rem', sm: '0.95rem', md: '1rem' },
            '& p': {
              margin: 0,
              marginBottom: 1.5,
              wordBreak: 'break-word',
              overflowWrap: 'break-word'
            },
            '& p:last-child': {
              marginBottom: 0
            },
            '& ul': {
              margin: 0,
              paddingLeft: { xs: 2, sm: 2.5 }
            },
            '& li': {
              marginBottom: 0.5,
              wordBreak: 'break-word',
              overflowWrap: 'break-word'
            }
          }}
          dangerouslySetInnerHTML={{ __html: about }} 
        />
      </CardContent>
    </Card>
  )
}

export default AboutBox
